'use strict';

var accordion = require('../../../../../../../../../../_virtual/accordion2.cjs');

(function (exports) {

	/**
	 * Controls the look and style of the Accordion
	 */ exports.ACCORDION_TYPES = void 0;
	(function(ACCORDION_TYPES) {
	    ACCORDION_TYPES["outlined"] = "outlined";
	    ACCORDION_TYPES["underlined"] = "underlined";
	})(exports.ACCORDION_TYPES || (exports.ACCORDION_TYPES = {}));
	exports.ACCORDION_DIRECTIONS = void 0;
	(function(ACCORDION_DIRECTIONS) {
	    ACCORDION_DIRECTIONS["left"] = "left";
	    ACCORDION_DIRECTIONS["right"] = "right";
	})(exports.ACCORDION_DIRECTIONS || (exports.ACCORDION_DIRECTIONS = {}));
	
} (accordion.__exports));
//# sourceMappingURL=accordion.cjs.map
